import { useDispatch } from "react-redux";
import { useLazyCompleteRegisterQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import { useNavigate } from "react-router-dom";
import useGetAccountApi from "../Account/getAccountApi";

const useRegisterCompletedApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [register] = useLazyCompleteRegisterQuery();
  const { get } = useGetAccountApi();
  const send = (body) => {
    dispatch(setLoader(true));

    register(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        navigate("/");

        setTimeout(() => {
          get();
        }, 100);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useRegisterCompletedApi;
